export default "__VITE_ASSET__DKkpPvx9__"